import { useMemo } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { ICustomFilter, ICustomFilterForm } from 'core/types';

interface IProps {
  isOpen: boolean;
  onClose: (reset: UseFormReset<ICustomFilterForm>) => void;
  onSubmit: (reset: UseFormReset<ICustomFilterForm>) => (data: ICustomFilterForm) => void;
  filter?: ICustomFilter;
}

export const UpsertFilterFormFields = ({ isOpen, onClose, onSubmit, filter }: IProps) => {
  const { t } = useTranslation();

  const isEdit = useMemo(() => !!filter?.id, [filter]);

  return (
    <Form
      isOpen={isOpen}
      title={isEdit ? t('titleEditFilter') : t('titleAddFilter')}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <FormField
        name="name"
        type={InputType.TEXT_INPUT}
        inputProps={{ label: t('labelName'), required: true }}
      />

      <FormField
        name="default"
        type={InputType.CHECKBOX}
        inputProps={{ label: t('labelDefaultFilter') }}
      />
    </Form>
  );
};
